module.exports = __webpack_public_path__ + "img/chart-walking-phase-average-new.752a6b8a.png";